import { render, staticRenderFns } from "./ValidIcon.vue?vue&type=template&id=4a15401e&scoped=true&"
import script from "./ValidIcon.vue?vue&type=script&lang=js&"
export * from "./ValidIcon.vue?vue&type=script&lang=js&"
import style0 from "./ValidIcon.vue?vue&type=style&index=0&id=4a15401e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a15401e",
  null
  
)

export default component.exports